// Bamizban's public contact details, shared by the footer and the Contact
// page so they can't drift apart. There is intentionally no physical address.
export const CONTACT_INFO = {
  email: "info.bamizban@gmail.com",
  phone: "09100298958",
  phoneDisplay: "۰۹۱۰ ۰۲۹ ۸۹۵۸",
  phoneHref: "tel:+989100298958",
  instagramHandle: "ba_mizban",
  instagramUrl: "https://www.instagram.com/ba_mizban",
};
